import { validatePwd } from "./util/general_util";
// require('jqueryui');


let REGISTER_LAST_PAGE_DISABLED = true;
//If user selected a specific form to edit with 'index', send them to that page
//If user selected the prev_but or next_but, set 'index' to either 0 or -1 
function set_register_dispPage(index:number) {
	let valid_indices:Array<number> = [1,2,3];
	let last_page_index:number = Math.max(...valid_indices);
	let j:number = 0;
	let cur_index:number = -1;
	let to_rem:number | null = null;
	let prev_disabled:boolean = $("#register-prevBut").parent().hasClass("disabled");
	let next_disabled:boolean = $("#register-nextBut").parent().hasClass("disabled");

	if ((index == 0 || index == -1)) {
		for (j = 0; j < valid_indices.length; j++) {
			if ($("#registerNav-" + valid_indices[j]).parent().hasClass("disabled")) {
				if (index == 0) cur_index = j;
				else if (index == -1) cur_index = j + 2;
				to_rem = valid_indices.indexOf(cur_index);
				break;
			};
		};
	} else {
		to_rem = valid_indices.indexOf(index);
		cur_index = index;
	};
	if (to_rem == null) return;
	if (prev_disabled) {
		if (cur_index != 1) $("#register-prevBut").parent().removeClass("disabled");
	} else if (cur_index == 1) $("#register-prevBut").parent().addClass("disabled");
	if (next_disabled) {
		if (cur_index != last_page_index) $("#register-nextBut").parent().removeClass("disabled");
	} else if (cur_index == last_page_index) $("#register-nextBut").parent().addClass("disabled");
	if (REGISTER_LAST_PAGE_DISABLED == true && cur_index == last_page_index - 1) $("#register-nextBut").parent().addClass("disabled");

	if (!$("#registerNav-" + cur_index).parent().hasClass("disabled")) {
		$("#registerNav-" + cur_index).parent().addClass("disabled");
	};
	if ($("#register-p" + cur_index).hasClass("d-none")) {
		$("#register-p" + cur_index).removeClass("d-none");
	};
	valid_indices.splice(to_rem, 1);
	j = 0;
	for (j = 0; j < valid_indices.length; j++) {
		if ($("#registerNav-" + valid_indices[j]).parent().hasClass("disabled")) {
			$("#registerNav-" + valid_indices[j]).parent().removeClass("disabled");
		};
		if (!$("#register-p" + valid_indices[j]).hasClass("d-none")) {
			$("#register-p" + valid_indices[j]).addClass("d-none");
		};
	};
};

$(document).on("click", "#register-prevBut", function(event){
	event.preventDefault();
	if ($(this).hasClass('disabled')) return;
	set_register_dispPage(0);
});
$(document).on("click", "#register-nextBut", function(event){
	event.preventDefault();
	let registerForm:JQuery<HTMLFormElement> = $("#register-form");
	let password:string = $("#register-password").val().toString();
	let passwordConfirm:string = $("#register-confirmPassword").val().toString();
	if (password != passwordConfirm) {
		(document.getElementById("register-confirmPassword") as HTMLInputElement).setCustomValidity("Please check that your passwords match");
		(document.getElementById("register-form") as HTMLFormElement).reportValidity();
	};
	if (!validatePwd(password)) {
		($("#register-password")[0] as HTMLInputElement).setCustomValidity("Password must have the following criteria:\n- 8 or more characters\n- a lowercase letter\n- an uppercase letter\n - a number\n- a special character ( !@#$%^&*()_+\-=[]{};:\|,.<>/?~ )");
		(document.getElementById("register-form") as HTMLFormElement).reportValidity();	
		return;
	};
	registerForm[0].reportValidity();
	let valid:boolean = registerForm[0].checkValidity();
	if (valid) {
		set_register_dispPage(-1);
	};
});

// $(document).on("click", "#contToFree", function() {
// 	set_register_dispPage(3);
// });
// $(document).on("click", "#1yrSub", function(event) {
// 	event.preventDefault();
// 	$("#subOption").val("1yr");
// 	$(this).closest("form").submit();
// });

// // $(document).on("modal.bs.shown","#modal-subscribe", function() {
// // 	$("input#subOption").val("none");
// // });

// // $(document).on("click","#skipFreeTrial", function() {
// // 	$("input#subOption").val("none");
// // });
  

// $(document).on("click","#startFreeTrial", function(event) {
// 	event.preventDefault();
// 	$("#subOption").val("7day-trial");
// 	$(this).closest("form").submit();
// });